import HeroSection from '../components/ui/heroSection';
import FeaturesSection from '../components/ui/featureSection';
import CTASection from '../components/ui/ctaSection';
import LandingDemoCanvasSection from '../components/ui/LandingDemoCanvasSection';
import './landingPage.css';
import logoWordmark from '../assets/brand/logos/wordmark-ink.svg';
import heroMain from '../assets/brand/landing/hero-main.png';
import heroSupport from '../assets/brand/photos/coding.png';
import goalIcon from '../assets/brand/svgs/gear.svg';
import structureIcon from '../assets/brand/svgs/keyboard.svg';
import awarenessIcon from '../assets/brand/landing/Eye Illustration.svg';
import paceIcon from '../assets/brand/svgs/megaphone.svg';

function AIUniversity() {
  return (
    <div className="index-page">
      <HeroSection
        tagline="Revolutionizing Education with AI Agents"
        description={
          <span className="description-text">
            In a world overflowing with generative AI content, Most Learned gives you clarity. Our
            intelligent agents transform scattered information into a living, adaptive curriculum,
            built around your passions, evolving with your goals. Sign up today for free.
          </span>
        }
        primaryButton={{ text: 'Sign Up', link: '/signup' }}
        secondaryButton={{ text: 'Login', link: '/login' }}
        logoSrc={logoWordmark}
        heroImageSrc={heroMain}
        supportImageSrc={heroSupport}
      />
      <LandingDemoCanvasSection />
      <FeaturesSection
        features={[
          {
            iconClass: 'ai-course-creation',
            iconSrc: goalIcon,
            title: 'AI-Native Course Creation',
            description:
              'Know what you want to learn, but ChatGPT gives you chaos? We turn your goal into a clear, personalized course. No guesswork.',
            link: '/ai-native-course-creation',
          },
          {
            iconClass: 'personalized-curriculum',
            iconSrc: structureIcon,
            title: 'Structured Self-Learning',
            description:
              'Tired of bouncing between AI, YouTube, and docs, and still forgetting what you learned? We bring it all together into one trackable path.',
            link: '/structured-self-learning',
          },
          {
            iconClass: 'adaptive-platform',
            iconSrc: awarenessIcon,
            title: 'Learner-Aware Guidance',
            description:
              'Most platforms teach one way. We adjust to YOUR way—hands-on, reflective, fast-paced, or deep dive.',
            link: '/learner-aware-guidance',
          },
          {
            iconClass: 'on-demand-scheduling',
            iconSrc: paceIcon,
            title: 'Pace That Fits Your Life',
            description:
              'Motivated but inconsistent? We keep you aligned, focused, and accountable. On your terms.',
            link: '/self-paced-structure',
          },
        ]}
      />
      <CTASection
        title="Step into the Future of Education"
        description="Join the next generation of learners who are reshaping education with personalized, AI-driven experiences. The future of learning starts now."
        buttonText="Join the Waitlist"
        buttonLink="https://docs.google.com/forms/d/18_T5_TnwqO3fcTK1srwpR4fjaA_BxFKd2aKQyBNtwl0" // This will direct users to your Typeform waitlist
      />
    </div>
  );
}

export default AIUniversity;
